<template>
  <v-card :disabled="disabled" :class="buttonCss" :height="height" :width="width"
          class="my-2 my-md-5 d-flex flex-column clickable" @click="$emit(action, actionParams)"
          v-if="visible">
    <v-badge v-if="showBadge" bordered color="error" icon="mdi-exclamation" overlap/>
    <v-flex class="d-flex align-center justify-center bottom-border">
      <v-icon v-if="hasNoDefaultSlot" color="primary" class="ma-6" x-large>{{ icon }}</v-icon>
      <slot/>
    </v-flex>
    <v-card-text class="white">
      <div class="caption justify-center justify-center ">{{ title }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class DynameatManagementButton extends Vue {
  @Prop({ Boolean, default: false, required: true }) showBadge;

  @Prop({ String, default: 'mdi-plus' }) icon;

  @Prop({ String, default: null, required: true }) action;

  @Prop({ Object, default: () => ({}), required: false }) actionParams;

  @Prop({ String, default: '', required: true }) title;

  @Prop({ Boolean, default: false }) disabled;

  @Prop({ Boolean, default: true }) visible;

  @Prop({ Boolean, default: false }) previous;

  get width() {
    if (this.$vuetify.breakpoint.smAndDown) return '190px';
    if (this.$vuetify.breakpoint.mdAndDown) return '220px';
    return '220px';
  }

  get height() {
    if (this.$vuetify.breakpoint.smAndDown) return '150px';
    if (this.$vuetify.breakpoint.mdAndDown) return '174px';
    return '174px';
  }

  get buttonCss() {
    return {
      secondary: !this.disabled && !this.previous,
      old: !this.disabled && this.previous
    };
  }

  get hasNoDefaultSlot() {
    return !this.$slots.default;
  }
}
</script>

<style>
.v-badge__badge .v-icon.v-icon {
  font-size: 12px;
  color: white;
}

</style>

<style scoped>
.bottom-border {
  border-bottom: 1px solid #d1d1d1;
}

.old {
  background-color: lightyellow !important;
  border-color: lightyellow !important;
}
</style>
